// Generated by CoffeeScript 2.7.0
var BaseModel, defineCurrentAttributesSet, uuid;

import GlobalID from 'libs/global_id.js';

import Utilities from 'helpers/utilities.js';

import ModelErrors from './model_errors.js';

({uuid} = Utilities);

defineCurrentAttributesSet = function() {
  if (_.has(this, 'currentAttributesSet')) {
    return this.currentAttributesSet;
  }
  return Object.defineProperty(this, 'currentAttributesSet', {
    enumerable: false,
    configurable: false,
    writable: false,
    value: {}
  });
};

export default BaseModel = (function() {
  class BaseModel {
    static getAttributeNames() {
      return _.keys(this.getAttributesSet());
    }

    static getAttributesSet() {
      return _.reduce(this.getAncestorConstructors().concat([this]), function(memo, constructor) {
        return _.extend(memo, constructor.currentAttributesSet);
      }, {});
    }

    static setAttributes(attributes) {
      defineCurrentAttributesSet.call(this);
      _.each(attributes, (attribute) => {
        var default_attribute;
        default_attribute = _.isObject(attribute) ? _.clone(attribute) : _.tap(new Object(), function(obj) {
          return obj[attribute] = void 0;
        });
        return _.extend(this.currentAttributesSet, default_attribute);
      });
      return this.currentAttributesSet;
    }

    static getSuperConstructor() {
      if (this !== BaseModel) {
        return Object.getPrototypeOf(this);
      }
    }

    static getAncestorConstructors() {
      return this.ancestor_constructors != null ? this.ancestor_constructors : this.ancestor_constructors = (() => {
        var ancestors, super_constructor;
        super_constructor = this.getSuperConstructor();
        ancestors = [];
        while (super_constructor) {
          ancestors.unshift(super_constructor);
          super_constructor = super_constructor.getSuperConstructor();
        }
        return ancestors;
      })();
    }

    constructor(raw_attributes = {}) {
      this.raw_attributes = raw_attributes;
      _.each(this.constructor.getAttributesSet(), (default_value, attribute_name) => {
        return this[attribute_name] = _.isBlank(this.raw_attributes[attribute_name]) ? _.clone(default_value) : this.raw_attributes[attribute_name];
      });
      if (!_.isBlank(this.raw_attributes['gid'])) {
        this.gid = GlobalID.locate(this.raw_attributes['gid']);
      }
      this.uuid = _.has(this.raw_attributes, 'uuid') ? this.raw_attributes.uuid : uuid();
      this.raw_attributes = _.pick(this.raw_attributes, this.constructor.getAttributeNames());
      this._destroy = false;
      this.errors = new ModelErrors(this);
    }

    isNew() {
      return this.id == null;
    }

    isPersisted() {
      return !this.isNew();
    }

    toJSON() {
      var object;
      object = _.pick(this, this.constructor.getAttributeNames());
      if (this.isPersisted()) {
        if (this._destroy) {
          return object;
        } else {
          return _.omit(object, '_destroy');
        }
      } else {
        return _.omit(object, 'id', '_destroy');
      }
    }

    destroy() {
      return this._destroy = true;
    }

    getI18nKey() {
      return this._i18n_key != null ? this._i18n_key : this._i18n_key = this.constructor.name.underscore();
    }

    setI18nKey(key) {
      return this._i18n_key = key;
    }

  };

  BaseModel.setAttributes(['id', '_destroy']);

  return BaseModel;

}).call(this);
